import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { Element } from 'dbweb-core';
import { IndexService, CardSize, CardType } from '../index.service';

@Component({
	selector: 'common-more-vert',
	templateUrl: './more-vert.component.html',
	styleUrls: ['./more-vert.component.scss']
})
export class MoreVertComponent implements OnInit {
	@HostBinding('class.c-index-more-vert') hostClass = true;
	// typeName: CardType;
	// theNavSize: CardSize;
	@Output() subMenuClick = new EventEmitter();
	// å­ç»ä»¶ä¼ å¼ å¡çåç§°
	private _typeName: CardType;
	@Input() set typeName(val: CardType) {
		this._typeName = val;
	}

	get typeName() {
		return this._typeName;
	}
	// å­ç»ä»¶ä¼ å¼ å¡çå°ºå¯¸ 100% |  2/3  | 1/3
	private _theNavSize: CardSize;
	@Input() set theNavSize(val: CardSize) {
		this._theNavSize = val;
	}
	get theNavSize() {
		return this._theNavSize;
	}
	// æ¯å¦æ¾ç¤ºâ1/3â

	// å­ç»ä»¶ä¼ å¼ äºçº§èåå¾ªç¯
	private _disElements: [];
	@Input() set disElements(val: []) {
		this._disElements = val;
	}
	get disElements() {
		return this._disElements;
	}
	private _disShow = false;
	@Input() set disShow(val: boolean) {
		this._disShow = val;
	}
	get disShow() {
		return this._disShow;
	}

	constructor(public svr: IndexService) {}

	ngOnInit() {}
	changeSize(sz: CardSize) {
		this.theNavSize = sz;
		this.svr.userSetting.Cards.find(x => x.Type === this.typeName).Size = this.theNavSize;
		this.svr.updateSetting().subscribe(() => {
			console.log(this.svr.userSetting.Cards);
		});
	}
	removeCard(cardName: string) {
		const arr = this.svr.userSetting.Cards;
		this.svr.userSetting.Cards = arr.filter((item: any) => item.Type !== cardName);
	}
	removeEle(i) {
		this.subMenuClick.emit(i);
	}
}
